import { n as t } from "./numberUtils-hMVh22IE.js";
import { o } from "./objectUtils-dSJXsCjS.js";
import { s as e } from "./stringUtils-EWGv0_ZV.js";
const n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  number: t,
  object: o,
  string: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as i
};
